import { BAOCustomElement } from '@bao/custom-element'
import { sectionRenderer } from '@bao/section-rendering'
import { getElement } from '@bao/utils'

let drawerLoaded = false

const REOPEN_DRAWER_KEYS = ['cart']

class CountrySelector extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.sessionStorageKey = 'countrySelector-lastOpenDrawer'

    if (drawerLoaded) return

    sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=dropdown`,
      )
      .then((res) => {
        drawerLoaded = true

        const newDOM = sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )

        const returnInput = getElement('[name="return_to"]', {
          context: newDOM,
        })

        returnInput.value = location.pathname

        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        this.reOpenDrawer()
      })
      .catch(() => {})
  }

  reOpenDrawer () {
    const reOpenKey = sessionStorage.getItem(this.sessionStorageKey)

    sessionStorage.removeItem(this.sessionStorageKey)

    if (!REOPEN_DRAWER_KEYS.includes(reOpenKey)) return

    this.siteDrawers.open(reOpenKey)
  }

  setupListeners () {
    this.listeners.add(this, 'input', this.handleInput.bind(this))
  }

  handleInput () {
    const reOpenKey = this.siteDrawers.reOpenKey

    if (REOPEN_DRAWER_KEYS.includes(reOpenKey)) {
      sessionStorage.setItem(this.sessionStorageKey, reOpenKey)
    } else {
      sessionStorage.removeItem(this.sessionStorageKey)
    }

    setTimeout(() => {
      this.els.form.element.submit()
    }, 0)
  }

  get siteDrawers () {
    return getElement('site-drawers')
  }
}

if (!customElements.get('country-selector')) {
  customElements.define('country-selector', CountrySelector)
}
